import ReactDOM from "react-dom/client";
import "./fonts/Inter-Black.woff";
import "./fonts/Inter-BlackItalic.woff";
import "./fonts/Inter-Bold.woff";
import "./fonts/Inter-BoldItalic.woff";
import "./fonts/Inter-ExtraBold.woff";
import "./fonts/Inter-ExtraBoldItalic.woff";
import "./fonts/Inter-ExtraLight.woff";
import "./fonts/Inter-ExtraLightItalic.woff";
import "./fonts/Inter-Italic.woff";
import "./fonts/Inter-Light.woff";
import "./fonts/Inter-LightItalic.woff";
import "./fonts/Inter-Medium.woff";
import "./fonts/Inter-MediumItalic.woff";
import "./fonts/Inter-Regular.woff";
import "./fonts/Inter-SemiBold.woff";
import "./fonts/Inter-SemiBoldItalic.woff";
import "./fonts/Inter-Thin.woff";
import "./fonts/Inter-ThinItalic.woff";
import "./index.css";

import { App } from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);
